// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M5.2 12.6C3.16 12.6 1.5 10.94 1.5 8.9C1.5 7.35 2.4 6.04 3.68 5.48C3.88 5.39 3.98 5.17 4.05 4.91C4.48 3.33 5.83 2.25 7.45 2.25C9.11 2.25 10.47 3.41 10.85 5.03C10.97 5.54 11.06 5.82 11.54 5.9C13.23 6.18 14.5 7.54 14.5 9.22C14.5 11.09 12.99 12.6 11.12 12.6H5.2Z',
];
